module.exports = __webpack_public_path__ + "static/img/14000524.6c4d3dba.png";